import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import CodeSelector from '../code-selector/code-selector.jsx';

import styles from './stop-all.css';
import closeIcon from './icon--close.png';
const StopAllComponent = function (props) {
    
    const {
        active,
        className,
        onClick,
        changeWidth,
        onChangeCode,
        robotType,
        robotArray,
        isRtl,
        ...componentProps
    } = props;
    return (
        <div
            className={classNames(styles.codeBox, className)}
        >
            <div
                className={classNames(styles.pyLab, className)}
            >
                {/* <FormattedMessage
                    className={classNames(
                        className,
                        styles.python,
                        {
                            [styles.isActive]: active
                        }
                    )}
                    defaultMessage="Code"
                    description="Blocks To Python"
                    id="gui.gui.editPanel"
                /> */}
                <CodeSelector
                    className={classNames(styles.download, className)}
                    onChangeCode={onChangeCode}
                    robotType={robotType}
                    robotArray={robotArray}
                />
                    
            </div>
            
            <div
                className={classNames(className, styles.draggabeLine)}
                onMouseDown={changeWidth}
                onTouchStart={changeWidth}
            />

            <div
                className={classNames(
                    className,
                    styles.stopAll,
                    {
                        [styles.isActive]: active
                    }

                )}
                draggable={false}
                id="toCode"
                wrap="off"
                {...componentProps}
                readOnly
            />
            
            <img
                className={classNames(
                    className,
                    styles.close,
                    {
                        [styles.isActive]: active
                    }
                )}
                draggable={false}
                src={closeIcon}
                onClick={onClick}
                {...componentProps}
            />
        </div>
    );
};

StopAllComponent.propTypes = {
    active: PropTypes.bool,
    changeWidth: PropTypes.func.isRequired,
    className: PropTypes.string,
    onChangeCode: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired
};

StopAllComponent.defaultProps = {
    active: false
};

export default StopAllComponent;
